import React from 'react'
import{useState,useEffect} from'react'
import Axios from'axios'
import "./Foods.css"
import{Link} from 'react-router-dom'
import Spinner from "../Common/Spinner"
let allData=[];
function Foods() {

  const [data,setData]=useState([]);
  const [serch,setSerch]=useState("");
  const [isLoading,changeIsLoading] = useState(true);

 
  // const name11=localStorage.getItem("name");


 
  // https://food-delivery-sid-api.herokuapp.com/api/read
  useEffect(()=>{
    Axios.get("https://food-delivery-sid-api.herokuapp.com/api/read")
    
  .then(response=>{
    
    allData=response.data;
    console.log(allData);
    setData(response.data);
    changeIsLoading(false)
    
  })
  .catch(err=>{
    console.log(err);
  })
  },[])

  function onSearchFieldChange(e){
    const fieldvalue=e.target.value;
    console.log(fieldvalue);
    
    const newdata=allData.filter((food)=>{
      return  food.foodname.toLowerCase().startsWith(fieldvalue.toLowerCase());
    })
    setSerch(fieldvalue);
    setData(newdata);
  }
  const handle=()=>{
    alert("Your order is placed")
  }

 

  return (
    <>
    
 
    
    <div className='food-full'>
      <div className='header-food'>
        <h2>zomato</h2>
        <input type={"text"} placeholder="Sheyamli Coloni"></input>
        <input onChange={(e)=>onSearchFieldChange(e)  } value={serch} type={"text"}placeholder="Search your Food" ></input>
        <p className='cart'>CART</p>
      </div>
      
      <div >
        <p className='name'>HOME / INDIA / Ranchi</p>
      </div>
      <div className='list'>
        <h2>Delivery</h2>
        <h2>Dining out</h2>
        <h2>Night life</h2>
      </div>
      <div >
        <ul className='tags'>
          <li className='l1'>Filter</li>
          <li className='l2'>Delivery Time</li>
          <li className='l3'>Rating 4.0+</li>
          <li className='l4'>Pure Veg</li>
        </ul>

      </div>
      <h1>Delivery Restaurants in Gwalior</h1>
      <div className='container121'>
     {
     (isLoading)?<div className='spinner'><Spinner/></div>:(
      data.map(food=>{
        return<>
        <div className='box2'>
         <div className='box'> 
         <img src={food.img}></img>
        <div className='rest-food'> 
         <h4>{food.restname}</h4> 
        <h5>{food.foodname}</h5>
        {/* <button>like</button> */}
        
        
        </div>
        
        
        <p className='avai'>{food.description}</p>
        <p>{food.price}</p>
        <button className='btn-ele' onClick={handle}>Add to cart</button>

        </div>
        </div>

        </>
  
       })
     )}
     </div>
    </div>
   
    </>
  )
}

export default Foods
